import { useTranslation } from "react-i18next";

export const StepIvalidCompanyCreditRisk = () => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 col-xs-12">
				<h2>{t("tooHighCreditRiskTitle")}</h2>
				<p dangerouslySetInnerHTML={{ __html: t("tooHighCreditRiskContent") }}></p>
			</div>
		</div>
	);
};
